import { Input } from "../ui/input";

interface RiskFactorPointFieldProps {
  label: string;
  description: string;
  points: number;
  onChange: (value: number) => void;
}

export function RiskFactorPointField({
  label,
  description,
  points,
  onChange,
}: RiskFactorPointFieldProps) {
  return (
    <div className="space-y-1.5">
      <label className="text-sm font-bold text-foreground">{label}</label>
      <Input
        type="number"
        value={points}
        onChange={(e) => onChange(parseInt(e.target.value) || 0)}
        min={0}
        max={10}
        className="h-9 border-border/60"
      />
      <p className="text-xs text-muted-foreground">{description}</p>
    </div>
  );
}
